import { render, staticRenderFns } from "./OpportunitiesModal.vue?vue&type=template&id=6be3d5e6&scoped=true&"
import script from "./OpportunitiesModal.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesModal.vue?vue&type=script&lang=js&"
import style0 from "./OpportunitiesModal.vue?vue&type=style&index=0&id=6be3d5e6&scoped=true&lang=css&"
import style1 from "./OpportunitiesModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be3d5e6",
  null
  
)

export default component.exports